// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "react18_ifl7/" + chunkId + "." + {"174":"4e34cc65ee89d6170a47","179":"3e82b9921308bb5a3040","240":"9c5c3693f81e7e0ea994","246":"5dd441b28565a7f6137d","440":"fe8ef0035c33395aef49","467":"0d21f5d102bfdbd15981","538":"5eaea37c0ad8ba4a6440","644":"f14f6d241a5da52f7731"}[chunkId] + ".js";
};